module.exports = __webpack_public_path__ + "media/images/fb-fabf820156d95913cbbb1730045288bd.svg";